import { action, makeObservable, observable } from 'mobx';

class GameStore {
  isBetsClosed = false;
  isNotification = false;
  isAnimationComplete = false;
  isShowAutoPlay = false;
  gameTypes = [];

  constructor() {
    makeObservable(this, {
      gameTypes: observable,
      isBetsClosed: observable,
      isAnimationComplete: observable,
      isNotification: observable,
      isShowAutoPlay: observable,
      setIsNotification: action.bound,
      setIsBetsClosed: action.bound,
      setIsShowAutoPlay: action.bound,
      setIsAnimationComplete: action.bound,
      setGameTypes: action.bound,
    });
  }

  setGameTypes(arg) {
    this.gameTypes = arg;
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setIsAnimationComplete(arg) {
    this.isAnimationComplete = arg;
  }

  setIsShowAutoPlay(bool) {
    this.isShowAutoPlay = bool;
  }

  setIsNotification() {
    this.isNotification = true;
    setTimeout(() => {
      this.isNotification = false;
    }, 1000);
  }
}

export const gameStore = new GameStore();
